import { makeAutoObservable } from 'mobx'

import { LocationValue } from '@flowwai-frontend/shared/common-components'

import { EntityConfig } from '../types'

export interface GeoLocationConfig {
   response: LocationValue
   onUpdateResponse: (response: LocationValue) => void
   entity?: EntityConfig | null
   addressFieldIds?: string[]

   isDisabled?: boolean
   isReadOnly?: boolean
   isRequired?: boolean
   showExtrusion?: boolean
}

class MapsUIStore {
   private _config!: GeoLocationConfig | null
   private _isGeoMapModalOpen!: boolean
   private _isMapsLoaded!: boolean

   constructor(isMapsLoaded: boolean) {
      this._isMapsLoaded = isMapsLoaded

      this.init()
      makeAutoObservable(this, {}, { autoBind: true })
   }

   init(): void {
      this._config = null
      this._isGeoMapModalOpen = false
   }

   get config(): GeoLocationConfig | null {
      return this._config
   }

   get isGeoMapModalOpen(): boolean {
      return this._isGeoMapModalOpen
   }

   get isMapsLoaded(): boolean {
      return this._isMapsLoaded
   }

   openGeoMapModal = (config: GeoLocationConfig): void => {
      this._isGeoMapModalOpen = true
      this._config = config
   }

   closeGeoMapModal = (): void => {
      this._isGeoMapModalOpen = false
   }

   setIsMapsLoaded = (isMapsLoaded: boolean): void => {
      this._isMapsLoaded = isMapsLoaded
   }

   clearStore(): void {
      this.init()
   }

   static create = (isMapsLoaded: boolean): MapsUIStore =>
      new MapsUIStore(isMapsLoaded)
}

export default MapsUIStore
